import { render, staticRenderFns } from "./goodsLimitItem.vue?vue&type=template&id=72c58915&"
import script from "./goodsLimitItem.vue?vue&type=script&lang=js&"
export * from "./goodsLimitItem.vue?vue&type=script&lang=js&"
import style0 from "./goodsLimitItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports